import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "stat-block__header" }
const _hoisted_2 = { class: "stat-block__value" }
const _hoisted_3 = {
  key: 1,
  class: "stat-block__percent--appg"
}
const _hoisted_4 = { class: "stat-block__title" }

import IconArrowDown from "@/assets/icons/IconArrowDown.vue";
import {computed} from "vue";

interface StatBlockProps {
  title: string;
  value: number | null | undefined;
  percent: number | null | undefined;
  isAppg: boolean;
  isMain?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StatBlock',
  props: {
    title: {},
    value: {},
    percent: {},
    isAppg: { type: Boolean },
    isMain: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const isPositivePercent = computed(() => props.percent != null && props.percent > 0);

const percentClass = computed(() => {
  if (props.isAppg) {
    return "stat-block__percent--appg";
  }

  if (isPositivePercent.value) {
    return props.isMain ? "stat-block__percent--positive-main" : "stat-block__percent--positive";
  } else {
    return props.isMain ? "stat-block__percent--negative-main" : "stat-block__percent--negative";
  }
});

const getFormattedValue = computed(() => {
  if (props.value == null) return "н/д";
  return props.value.toLocaleString();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["stat-block", {'stat-block--main': __props.isMain}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(getFormattedValue.value), 1),
      (props.value != null)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["stat-block__percent", [percentClass.value]])
          }, [
            (!__props.isAppg)
              ? (_openBlock(), _createBlock(IconArrowDown, {
                  key: 0,
                  class: _normalizeClass(["stat-block__arrow", {'stat-block__arrow--positive': isPositivePercent.value}])
                }, null, 8, ["class"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, "АППГ")),
            _createTextVNode(" " + _toDisplayString(__props.percent?.toFixed(1) ?? '0.0') + "% ", 1)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("span", _hoisted_4, _toDisplayString(props.title), 1)
  ], 2))
}
}

})